import '../../style/base.css';
import '../../info/index.css';
import '../../icon/index.css';
import '../index.css';


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/checkbox/style/index.js
// module id = 404
// module chunks = 0